<template>
  <div
    :class="[
      'result-list-view',
      {
        'is-mobile': isMobile,
        'is-tablet': isTablet,
        'is-large-tablet': isLargeTablet,
        'is-laptop': isLaptop,
        'is-desktop': isDesktop,
        'is-huge': isHuge,
      },
    ]"
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { isDesktop, isHuge, isLaptop, isLargeTablet, isMobile, isTablet } from '@/core/helpers/ui.helper';
</script>

<style lang="scss" scoped>
.result-list-view {
  position: relative;
  width: 416px;
  border-right: 1px solid var(--color-white-5);

  &.is-mobile {
    width: 100%;
    height: 100%;
  }

  &.is-tablet {
    width: 340px;
  }

  &.is-large-tablet {
    width: 417px;
  }

  &.is-laptop {
    width: 417px;
  }

  &.is-desktop {
    width: 417px;
  }

  &.is-huge {
    width: 530px;
  }
}
</style>
